import { useCallback, useMemo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddGuestsField = ({
  guestEmail,
  guestCount,
  errorMessage,
  tooltipMessage,
  isRescheduling,
  isValidatingEmail,
  maxGuestCount,
  handleInputChange,
  handleAddGuest
}) => {
  const hasError = errorMessage !== null;
  const reachedMaxGuestCount = guestCount === maxGuestCount;
  const addButtonDisabled = hasError || guestEmail.length === 0 || reachedMaxGuestCount || isValidatingEmail;
  const renderedAddButton = useMemo(() => {
    const button = /*#__PURE__*/_jsx(LoadingButton, {
      "aria-label": I18n.text('prebook.details.addGuests.addButtonAriaLabel'),
      marginInlineStart: "-600",
      "data-selenium-test": "meetings-add-guests-field-add-btn",
      "data-test-id": "meetings-add-guests-field-add-btn",
      use: "tertiary-light",
      onClick: handleAddGuest,
      disabled: addButtonDisabled,
      loading: isValidatingEmail,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "add"
      })
    });
    const hasTooltipMessage = tooltipMessage !== null;
    if (hasTooltipMessage) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: tooltipMessage,
        children: button
      });
    }
    return button;
  }, [addButtonDisabled, isValidatingEmail, tooltipMessage, handleAddGuest]);
  const handleEnterKeyPress = useCallback(evt => {
    const charCode = evt.key || evt.code;
    if (!charCode) return;
    const enterKeyPressed = charCode.toLowerCase() === 'enter';
    if (enterKeyPressed && !addButtonDisabled) {
      handleAddGuest();
    }
  }, [handleAddGuest, addButtonDisabled]);
  return /*#__PURE__*/_jsxs(Grid, {
    "data-test-id": "meetings-add-guests-field",
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: 6,
      children: /*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('prebook.details.addGuests.inputAriaLabel'),
        validationMessage: errorMessage,
        error: hasError,
        paddingInlineStart: "200",
        children: /*#__PURE__*/_jsx(TextInput, {
          "data-selenium-test": "meetings-add-guests-field-input",
          "data-test-id": "meetings-add-guests-field-input",
          value: guestEmail,
          onChange: handleInputChange,
          onKeyDown: handleEnterKeyPress,
          disabled: reachedMaxGuestCount || isRescheduling,
          placeholder: I18n.text('prebook.details.addGuests.inputPlaceholder'),
          dir: guestEmail ? 'auto' : undefined
        })
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [renderedAddButton, /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          marginInlineStart: "200",
          typography: "heading-25",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "prebook.details.addGuests.guestCount",
            options: {
              currentCount: guestCount,
              maxCount: maxGuestCount
            }
          })
        })]
      })
    })]
  });
};
export default AddGuestsField;